import { Link } from "react-router-dom";

export const PublicNav = ({ variant = "solid" }) => (
  <header className={`sticky top-0 z-40 border-b ${variant === "transparent" ? "bg-background/70 backdrop-blur" : "bg-background"}`}>
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <Link to="/" className="font-heading text-xl font-bold tracking-tight" data-testid="public-brand-link">BIIPP</Link>
      <nav className="flex items-center gap-2 sm:gap-3">
        <Link to="/login" data-testid="public-nav-login">
          <span className="inline-flex items-center rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Log in</span>
        </Link>
        <Link to="/signup" data-testid="public-nav-signup">
          <span className="inline-flex items-center rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground hover:bg-primary/90 transition-colors">Get started</span>
        </Link>
      </nav>
    </div>
  </header>
);

export const PublicFooter = () => (
  <footer className="border-t bg-background">
    <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-center sm:text-left">
          <p className="font-heading text-base font-bold tracking-tight">BIIPP</p>
          <p className="text-xs text-muted-foreground mt-1">Calm reminders for everything that expires.</p>
        </div>
        <nav className="flex items-center gap-5 text-sm text-muted-foreground">
          <Link to="/privacy" className="hover:text-foreground transition-colors" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground transition-colors" data-testid="footer-terms-link">Terms</Link>
          <Link to="/login" className="hover:text-foreground transition-colors">Log in</Link>
        </nav>
      </div>
      <p className="mt-8 text-xs text-muted-foreground/70 text-center sm:text-left">
        © {new Date().getFullYear()} BIIPP. All rights reserved.
      </p>
    </div>
  </footer>
);
